/**
 * DCMS FRONTEND API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { TreatmentPlan } from './treatmentPlan';
import { TreatmentPlanPermissions } from './treatmentPlanPermissions';


/**
 * The treatment plan tab: the plan (``null`` before the first save) and what the create view needs.
 */
import {ValidatorFn, Validators} from "@angular/forms";

export interface PatientTreatmentPlan { 
    plan: TreatmentPlan | null;
    collaboardUrlTemplate: string;
    permissions: TreatmentPlanPermissions;
}
export const PatientTreatmentPlan_plan_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const PatientTreatmentPlan_collaboardUrlTemplate_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const PatientTreatmentPlan_permissions_Validators: ValidatorFn[] =
    [  Validators.required, ];


